import DefaultContainer from "../../../../Components/General/Dashboard/Default/DefaultContainer";

const Default = () => {
  return <DefaultContainer />;
};

export default Default;
